import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const FullMatchMatcher: FieldMatcher = {
  name: 'fullMatch',
  displayName: 'Matches',
  hasEditor: true,
  options: {
    chipFormatter: (value: string) => `: ${value}`,
  },
};